import { createAppAsyncThunk } from 'src/store/utils/thunks';
import { wsEsSend } from '@skynet/data-ws-es';
import { ReportCommands } from 'src/store/shared/reports/types';
import type { ConfirmReportPayload, RequestReportPayload } from 'src/store/shared/reports/types';

export const requestReport = createAppAsyncThunk(
  'reports/requestReport',
  (payload: RequestReportPayload, thunkApi) =>
    thunkApi.dispatch(
      wsEsSend({
        command: ReportCommands.GetReport,
        ...payload,
      }),
    ),
);

export const confirmReport = createAppAsyncThunk(
  'reports/confirmReport',
  (payload: ConfirmReportPayload, thunkApi) =>
    thunkApi.dispatch(
      wsEsSend({
        command: ReportCommands.SendReport,
        ...payload,
      }),
    ),
);

export const cancelReport = createAppAsyncThunk(
  'reports/cancelReport',
  (payload: ConfirmReportPayload, thunkApi) =>
    thunkApi.dispatch(
      wsEsSend({
        command: ReportCommands.CancelReport,
        ...payload,
      }),
    ),
);
